import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import dayjs from 'dayjs';
import { Api } from 'src/smoothr-web-app-core/api/api';
import Customer from 'src/smoothr-web-app-core/models/Customer';
import Order from 'src/smoothr-web-app-core/models/Order';

@Component({
	selector: 'app-my-orders-modal',
	templateUrl: './my-orders-modal.component.html',
	styleUrls: ['./my-orders-modal.component.scss'],
	standalone: false,
})
export class MyOrdersModalComponent implements OnInit {
	public customer: Customer;
	public orders: Order[] = [];
	public loading = false;

	constructor(private modalCtrl: ModalController) {}

	get openOrders(): Order[] {
		return this.orders.filter(value => dayjs(value.orderAt).add(30, 'minutes').isSameOrAfter(dayjs()));
	}

	get doneOrders(): Order[] {
		return this.orders.filter(value => dayjs(value.orderAt).add(30, 'minutes').isBefore(dayjs()));
	}

	static async show(modalCtrl: ModalController, customer: Customer): Promise<void> {
		console.log(customer);
		const modal = await modalCtrl.create({
			cssClass: 'item-modal',
			component: MyOrdersModalComponent,
			componentProps: {
				customer,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}

	ngOnInit() {
		this.loadOrders();
	}

	loadOrders() {
		this.orders = [];
		if (!this.customer) {
			console.log('user not loaded');

			return;
		}
		this.loading = true;
		Api.getCustomerOrders(this.customer.uid)
			.then(res => {
				this.orders = res.data.withPayment;
				console.log(this.orders);
				this.loading = false;
			})
			.catch(err => {
				console.log(err);
				this.loading = false;
			});
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
